import React from "react";
import Select from "react-select";

function CustomReactSelect(props) {
	const {
		options,
		value,
		onChange,
		name,
		className,
		isDisabled,
		paginationDropDown,
		placeholder,
		isSearchable,
		multipule,
	} = props;

	//Custom Styling
	const ReactSelectStyle = {
		container: (provided) => ({
			...provided,
			"&:hover": {
				border: "0px",
			},
			"&:focus": {
				border: "0px",
			},
		}),
		control: (base) => ({
			...base,
			fontFamily: "Poppins",
			fontSize: "13px",
			boxShadow: "none",
			border:
				paginationDropDown || isDisabled ? "1px solid #ced4da" : "0px",
			borderRadius: "10px",
			"&:hover": {
				border: paginationDropDown ? "1px solid #bec1c4" : "0px",
			},
		}),
		menu: (base) => ({
			...base,
			fontFamily: "Poppins",
			fontSize: "13px",
		}),
		menuPortal: (styles) => ({ ...styles, zIndex: 1000 }),
		option: (styles, { isFocused, isSelected }) => ({
			...styles,
			background: isSelected ? "#068587" : "white",
			color: isSelected ? "white" : "#068587",
			"&:hover": {
				background: isFocused ? "#0685872e" : "white",
				color: "black",
			},
		}),
	};

	return (
		<Select
			menuPlacement="auto"
			styles={ReactSelectStyle}
			options={options}
			value={value}
			isMulti={multipule || false}
			onChange={(value, event) => onChange(value, event)}
			name={name || ""}
			className={className || ""}
			classNamePrefix="react-select"
			placeholder={placeholder || "Select"}
			isSearchable={!isSearchable}
			isDisabled={isDisabled || false}
		/>
	);
}

export default CustomReactSelect;
